module.exports = __webpack_public_path__ + "img/confirm.4795c6b3.svg";